// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3j8Sj","unreadBadge":"styles_unreadBadge__5R-ix","modalContent":"styles_modalContent__18RRb","modal":"styles_modal__3vBHW"};